import React, { useState, useEffect } from 'react'
import axiosJWT from '../../JwtToken'

export const DrafPKS = ({ rowID, requestCode, getData, closePKS, getPesan, setMsg }) => {

    const [loading, setLoading] = useState(false)

    const [formData, setFormData] = useState({
        namaBarangJasa: '',
        nilaiTransaksi: 0,
        tanggalMulai: '',
        tanggalSelesai: '',
        durasiKontrak: '',
        // masaCacatHari: 0,
        detailBarang: [{ no: 1, namaBarang: '', spesifikasiTeknis: '', satuan: '', hargaSatuan: 0, volume: 0, totalHarga: 0 }],
        namaPenandatanganPihak1: '',
        namaPenandatanganPihak2: '',
        jabatanPihak1: '',
        jabatanPihak2: ''
    })

    useEffect(() => {
        if (formData.tanggalMulai && formData.tanggalSelesai) {
            const durasi = hitungDurasi(formData.tanggalMulai, formData.tanggalSelesai)
            setFormData(prev => ({ ...prev, durasiKontrak: durasi }))
        }
    }, [formData.tanggalMulai, formData.tanggalSelesai])

    const handleDetailChange = (index, field, value) => {
        const newDetails = [...formData.detailBarang]
        newDetails[index][field] = value

        if (field === 'hargaSatuan' || field === 'volume') {
            newDetails[index].totalHarga = newDetails[index].hargaSatuan * newDetails[index].volume
        }

        const grandTotal = newDetails.reduce((sum, item) => sum + item.totalHarga, 0)
        setFormData({ ...formData, detailBarang: newDetails, nilaiTransaksi: grandTotal })
    }

    const addDetailRow = () => {
        setFormData({ ...formData, detailBarang: [...formData.detailBarang, { no: formData.detailBarang.length + 1, namaBarang: '', spesifikasiTeknis: '', satuan: '', hargaSatuan: 0, volume: 0, totalHarga: 0 }] })
    }

    const hitungDurasi = (start, end) => {
        if (!start || !end) return ''

        const startDate = new Date(start)
        const endDate = new Date(end)

        let years = endDate.getFullYear() - startDate.getFullYear()
        let months = endDate.getMonth() - startDate.getMonth()
        let days = endDate.getDate() - startDate.getDate()

        if (days < 0) {
            months--
            // Dapatkan jumlah hari dalam bulan sebelumnya
            const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0)
            days += prevMonth.getDate()
        }
        if (months < 0) {
            years--
            months += 12
        }

        let result = []
        if (years > 0) result.push(`${years} Tahun`)
        if (months > 0) result.push(`${months} Bulan`)
        if (days > 0) result.push(`${days} Hari`)

        return result.join(' ')
    }

    const proses = async (e) => {
        e.preventDefault()
        setLoading(true)

        try {
            const payload = { ...formData, requestProcurementId: rowID, requestCode }
            const response = await axiosJWT.post(`/api/pks/create`, payload)
            getPesan()
            setMsg(response.data.msg)
            setTimeout(() => {
                getPesan()
                setMsg('')
                getData('')
                closePKS()
            }, 2000)
        } catch (err) {
            getPesan()
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                ? err.response.data.msg
                : 'Maaf, proses pengiriman data gagal!'
            setMsg(errorMsg)
            setTimeout(() => {
                getPesan()
                setMsg('')
            }, 4000)
        } finally {
            setLoading(false)
        }
    }

    return (
        <form onSubmit={proses} className="form-horizontal">
            <div className="row">
                {/* Info Utama */}
                <div className="form-group col-md-12">
                    <label className="control-label">Nama Barang/Jasa</label>
                    <input type="text" className="form-control" onChange={(e) => setFormData({ ...formData, namaBarangJasa: e.target.value })} required />
                </div>

                {/* Detail Waktu & Durasi */}
                <div className="form-group col-md-4">
                    <label className="control-label">Tanggal Mulai</label>
                    <input type="date" className="form-control" onChange={(e) => setFormData({ ...formData, tanggalMulai: e.target.value })} required />
                </div>
                <div className="form-group col-md-4">
                    <label className="control-label">Tanggal Selesai</label>
                    <input type="date" className="form-control" onChange={(e) => setFormData({ ...formData, tanggalSelesai: e.target.value })} required />
                </div>
                <div className="form-group col-md-4">
                    <label className="control-label">Durasi (Auto-Calc)</label>
                    <input
                        type="text"
                        className="form-control"
                        value={formData.durasiKontrak}
                        readOnly
                        style={{ backgroundColor: '#eee' }}
                    />
                </div>

                {/* <div className="form-group col-md-6">
                    <label className="control-label">Masa Cacat (Hari)</label>
                    <input
                        type="number"
                        className="form-control"
                        placeholder="Contoh: 90"
                        onChange={(e) => setFormData({ ...formData, masaCacatHari: parseInt(e.target.value) || 0 })}
                    />
                </div> */}

                {/* Tabel Detail */}
                <div className="col-md-12">
                    <label className="control-label">Rincian Barang/Jasa</label>
                    <table className="table table-bordered">
                        <thead><tr><th>Nama Barang</th><th>Spek</th><th>Satuan</th><th>Harga</th><th>Vol</th><th>Total</th></tr></thead>
                        <tbody>
                            {formData.detailBarang.map((item, idx) => (
                                <tr key={idx}>
                                    <td><input type="text" className="form-control" onChange={(e) => handleDetailChange(idx, 'namaBarang', e.target.value)} /></td>
                                    <td><input type="text" className="form-control" onChange={(e) => handleDetailChange(idx, 'spesifikasiTeknis', e.target.value)} /></td>
                                    <td><input type="text" className="form-control" onChange={(e) => handleDetailChange(idx, 'satuan', e.target.value)} /></td>
                                    <td><input type="number" className="form-control" onChange={(e) => handleDetailChange(idx, 'hargaSatuan', parseInt(e.target.value) || 0)} /></td>
                                    <td><input type="number" className="form-control" onChange={(e) => handleDetailChange(idx, 'volume', parseInt(e.target.value) || 0)} /></td>
                                    <td>{item.totalHarga.toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button type="button" className="btn btn-sm btn-raised btn-info" onClick={addDetailRow}><i className="fa fa-plus"></i> Baris</button>
                </div>

                {/* Penandatangan Pihak 1 (Dinas) */}
                <div className="form-group col-md-6">
                    <label className="control-label">Nama Penandatangan Pihak 1 (Buyer)</label>
                    <input type="text" className="form-control" onChange={(e) => setFormData({ ...formData, namaPenandatanganPihak1: e.target.value })} required />
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Jabatan Pihak 1</label>
                    <input type="text" className="form-control" onChange={(e) => setFormData({ ...formData, jabatanPihak1: e.target.value })} required />
                </div>

                {/* Penandatangan Pihak 2 (Vendor) */}
                <div className="form-group col-md-6">
                    <label className="control-label">Nama Penandatangan Pihak 2 (Vendor)</label>
                    <input type="text" className="form-control" onChange={(e) => setFormData({ ...formData, namaPenandatanganPihak2: e.target.value })} required />
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">Jabatan Pihak 2</label>
                    <input type="text" className="form-control" onChange={(e) => setFormData({ ...formData, jabatanPihak2: e.target.value })} required />
                </div>
            </div>

            <div className="modal-footer">
                <button disabled={loading} className="btn btn-raised btn-success br-2" type="submit">
                    <i className="fa fa-save"></i> {loading ? 'Menyimpan...' : 'Simpan Draf'}
                </button>
                <button className="btn btn-raised btn-danger br-2" type="button" onClick={closePKS}><i className="fa fa-sign-out"></i> Tutup</button>
            </div>
        </form>
    )
}